import { Link, useParams } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { services } from '@/mocks/site';

const heroImg: Record<string, string> = {
  'wellness-care': 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20calm%20wellness%20exam%20of%20a%20small%20dog%20by%20a%20gentle%20veterinarian%20in%20a%20bright%20modern%20warm%20veterinary%20clinic%20with%20soft%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20real%20unhurried%20clinical%20moment%2C%20natural%20skin%20tones%2C%20not%20stock%20photography&width=1080&height=660&seq=svcdetail-wellness&orientation=landscape',
  'dental-care': 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20veterinary%20dental%20check%20on%20a%20medium%20dog%20in%20a%20bright%20modern%20warm%20veterinary%20clinic%20with%20soft%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20real%20focused%20clinical%20moment%2C%20natural%20skin%20tones&width=1080&height=660&seq=svcdetail-dental&orientation=landscape',
  'diagnostics': 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20veterinarian%20reviewing%20digital%20imaging%20with%20a%20calm%20cat%20nearby%20in%20a%20bright%20modern%20warm%20veterinary%20clinic%2C%20soft%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20quiet%20focused%20professional%20moment&width=1080&height=660&seq=svcdetail-diag&orientation=landscape',
  'surgery': 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20small%20dog%20recovering%20on%20a%20warm%20blanket%20in%20a%20bright%20modern%20veterinary%20recovery%20room%20with%20soft%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20quiet%20calm%20restful%20clinical%20setting&width=1080&height=660&seq=svcdetail-surgery&orientation=landscape',
  'urgent-care': 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20calm%20same-day%20triage%20moment%20with%20a%20small%20dog%20and%20a%20focused%20veterinary%20professional%20in%20a%20bright%20modern%20warm%20veterinary%20clinic%20with%20soft%20natural%20daylight%2C%20warm%20off%20white%20background&width=1080&height=660&seq=svcdetail-urgent&orientation=landscape',
};

export default function ServiceDetail() {
  const { slug } = useParams();
  const svc = services.find(s => s.slug === slug) || services[0];
  const related = services.filter(s => svc.related.includes(s.slug));
  const img = heroImg[svc.slug] || heroImg['wellness-care'];

  return (
    <Layout>
      <section className="pt-16 md:pt-20 pb-6">
        <div className="max-w-container mx-auto px-5 md:px-12">
          <Link to="/services" className="inline-flex items-center gap-2 text-[14px] text-muted hover:text-ink cursor-pointer">
            <i className="ri-arrow-left-line"></i> Back to All Services
          </Link>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-container mx-auto px-5 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">{svc.index} · {svc.group}</div>
            <h1 className="mt-3 font-display font-bold text-[44px] md:text-[64px] leading-[1.02] text-cocoa">{svc.title}</h1>
            <p className="mt-6 text-[18px] text-ink/80 leading-relaxed max-w-text">{svc.short}</p>
          </div>
          <div className="lg:col-span-5">
            <div className="img-hover w-full aspect-[4/3] rounded-[32px] overflow-hidden bg-line">
              <img src={img} alt={svc.title} className="w-full h-full object-cover object-top" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 border-t border-line">
        <div className="max-w-container mx-auto px-5 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-[13px] font-semibold text-muted uppercase tracking-wider">What this visit covers</div>
          </div>
          <div className="lg:col-span-8">
            <ul className="space-y-4">
              {svc.covers.map(c => (
                <li key={c} className="flex gap-4 text-[17px] text-ink/90">
                  <span className="w-6 h-6 flex items-center justify-center text-care mt-0.5"><i className="ri-check-line text-[18px]"></i></span>
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-16 border-t border-line">
        <div className="max-w-container mx-auto px-5 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-[13px] font-semibold text-muted uppercase tracking-wider">When to book</div>
          </div>
          <div className="lg:col-span-8">
            <p className="text-[18px] text-ink/85 leading-relaxed max-w-text">{svc.whenToBook}</p>
          </div>
        </div>
      </section>

      <section className="py-16 border-t border-line">
        <div className="max-w-container mx-auto px-5 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-[13px] font-semibold text-muted uppercase tracking-wider">What to expect</div>
          </div>
          <div className="lg:col-span-8">
            <p className="text-[18px] text-ink/85 leading-relaxed max-w-text">{svc.expect}</p>
          </div>
        </div>
      </section>

      <section className="py-16 border-t border-line">
        <div className="max-w-container mx-auto px-5 md:px-12">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">Related services</div>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {related.map(r => (
              <Link key={r.slug} to={`/services/${r.slug}`} className="module-lift group block p-6 rounded-[28px] border border-line hover:border-cocoa/25 transition-colors cursor-pointer bg-warm">
                <div className="flex items-center justify-between">
                  <span className="text-[13px] font-semibold text-muted">{r.index}</span>
                  <i className="ri-arrow-right-up-line text-[18px] text-muted group-hover:text-cocoa"></i>
                </div>
                <h3 className="mt-4 font-display font-semibold text-[22px] text-cocoa">{r.title}</h3>
                <p className="mt-2 text-[14px] text-ink/70 leading-relaxed">{r.short}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-container mx-auto px-5 md:px-12">
          <div className="rounded-[36px] p-10 md:p-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6" style={{ background: '#F2D16B' }}>
            <div>
              <h2 className="font-display font-bold text-[30px] md:text-[40px] leading-[1.05] text-cocoa">Book a {svc.title.toLowerCase()} visit.</h2>
              <p className="mt-3 text-ink/80 text-[16px] max-w-[520px]">We'll confirm your appointment within one business day.</p>
            </div>
            <Link to="/book" className="btn-motion group inline-flex items-center gap-2 h-[54px] px-8 rounded-full bg-cocoa hover:bg-careDark text-white text-[15px] font-semibold cursor-pointer whitespace-nowrap">
              Book an Appointment <i className="link-arrow-icon ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}